import {Injectable , SecurityContext} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";


export enum MarkOperator {
	StartsWith, EndsWith, Contains, Equals,DateEquals
}

@Injectable({ providedIn: 'root' })
  export class MarkService {
	constructor(private sanitizer: DomSanitizer) {
	}

	public highlightField(field:(string|number), searchTerms:string[], operator:MarkOperator, prefix:string, suffix:string) : string {
		let found:boolean = false;
		let startIndex:number, endIndex:number;

		if (!field) {
			return '';
		} else if (!isNaN(<any>field)) {
			field = '' + field;
		}
		field = <string>field;

		searchTerms.some((searchTerm) => {
			if (operator === MarkOperator.DateEquals) {
				if (field === searchTerm) {
					found = true;
					startIndex = 0;
					endIndex = field.length;
				}
			} else if (operator === MarkOperator.Equals) {
				if ((<string>field).toLowerCase() === (<string>searchTerm).toLowerCase()) {
					found = true;
					startIndex = 0;
					endIndex = (<string>field).length;
				}
			} else {
				searchTerm = <string>searchTerm;
				for (let i = 0; i < (<string>field).length - searchTerm.length + 1; ++i) {
					for (let j = 0; j < searchTerm.length; ++j) {
						let firstChar = field[i + j].toLowerCase();
						let secondChar = searchTerm[j].toLowerCase();

						if (firstChar !== secondChar) {
							break;
						}

						if (j === searchTerm.length - 1) {
							switch (operator) {
								case MarkOperator.StartsWith:
									found = (i === 0);
									break;
								case MarkOperator.EndsWith:
									found = (i+j+1 === (<string>field).length);
									break;
								default:
									found = true;
									break;
							}

							if (found) {
								startIndex = i;
								endIndex = i+j+1;
							}
						}
					}

					if (found || operator === MarkOperator.StartsWith) {
						break;
					}
				}
			}

			return found;
		});

		if (found) {
			return (this.sanitize(field.substring(0, startIndex)) +
				prefix +
				this.sanitize(field.substring(startIndex, endIndex)) +
				suffix +
				this.sanitize(field.substring(endIndex)));
		}

		return this.sanitize(field);
	}

	public sanitize(v:string) {
		return this.sanitizer.sanitize(SecurityContext.HTML, this.removeUnSafeTags(v));
	}

	private removeUnSafeTags(v:string) {
		if (typeof(v)!=='string'){
			return v;
		}
		// encode this since we're going to use it in [innerHTML]. angular interpolation will keep tags like <img>
		// (this is lucky since we need it for the <strong> tabs), so we remove this here intentionally so it's not parsed
		// as html.
		const TRANSFORM_CHARS:Map<string, string>= new Map();
		TRANSFORM_CHARS.set("&","&amp;");
		TRANSFORM_CHARS.set("<","&lt;");
		TRANSFORM_CHARS.set(">","&gt;");
		TRANSFORM_CHARS.set('"',"&quot;");
		TRANSFORM_CHARS.set("'","&#39;");
		TRANSFORM_CHARS.forEach((val,key)=>{
			v = v.replace(key,val);
		});
		return v;
	}
}
